import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslocoModule } from '@jsverse/transloco';
import { combineLatest, map, Observable } from 'rxjs';

import { GlobalState } from '../../store/store.model';
import { selectRouteData } from '../../store/router.selectors';
import { Tab, TabModel, tabs } from '@components/footer/tabs';
import { TabVisibilityService } from '@components/footer/tab-visibility.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgIf, AsyncPipe, NgForOf, TranslocoModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly store = inject(Store<GlobalState>);
  private readonly router = inject(Router);
  private readonly tabVisibility = inject(TabVisibilityService);

  public readonly visibleTabs$: Observable<TabModel[]> = combineLatest([
    this.store.select(selectRouteData),
    this.tabVisibility.visibilityChanged$,
  ]).pipe(
    map(([data]) => {
      const activeKey = data?.['tab'];

      return tabs
        .map((tab: TabModel) => ({
          ...tab,
          active: tab.key === activeKey,
          hidden: this.tabVisibility.isTabHidden(tab.key),
        }))
        .filter((tab) => !tab.hidden);
    }),
  );

  public select(tab: TabModel): void {
    void this.router.navigate([`/tabs/${tab.key}`]);
  }

  public trackByKey(_: number, tab: TabModel): Tab | undefined {
    return tab?.key;
  }
}
